import { componentList } from "@/services/globalComponents";
const WidgetName = (type) => {
    if (componentList[type])
        return componentList[type].displayName;
    else
        return type;
};
export default WidgetName;
